export enum BuildProfileTab {
  Overview,
  Settings,
  Log,
  Delete
}
